import { BookmarkPlusIcon } from './BookmarkPlusIcon';

/**
 * author: Austin Andrews
 * id 596822BD-8373-402C-9D27-C341405F55F9
 * name bookmark-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-plus.svg
 * tags
 */
export const BookmarkAddIcon = BookmarkPlusIcon;
export default BookmarkAddIcon